import { FC, useCallback, useState } from "react"
import { organizationDeleteApi } from "src/domain/api/organization/organizationDeleteApi"
import { Organization } from "src/domain/entities/organization"
import { useAuth } from "../../../domain/hooks"
import { getErrorMessage } from "../../../utils/helpers"
import DeleteItemDialog from "../../shared/DeleteItemDialog"

interface Props {
	organization: Organization
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const OrganizationDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	organization,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleOrganizationDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await organizationDeleteApi({ id: organization.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [organization, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Organization: ${organization.name.en}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleOrganizationDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
